import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Best blogging week I have ever had",
  "description": "",
  "published": "2011-11-21T00:00:00.000Z",
  "redirect_from": ["/blog/best-blogging-week-i-have-ever-had/swizec/3025"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Somewhere around June this year I set a challenge for myself. I wanted a sustained 20k visitors every month on swizec.com by the end of the calendar year.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-21-at-7.30.53-PM-300x206.png",
        "alt": "It's a spike!",
        "title": "It's a spike!"
      }}></img></p>
    <p>{`The only real step towards this goal was to start blogging regularly. At first I would blog exactly twice a week on specific days, eventualy I started blogging daily.`}</p>
    <p>{`Here's the strange thing - it actually worked.`}</p>
    <p>{`By blogging every day I have ensured not all of my posts will be super brilliant, but the sheer amount of practice I'm getting has meant that even on my worst days I can simply sit down and pump something out. Even if it's dreck, even if I feel nobody will be interested. Such posts only end up as a reminder for people that hey, there's this blog, you sometimes like it ... it's still alive. Just letting you know!`}</p>
    <p>{`Last week something strange happened.`}</p>
    <p>{`I filled my monthly "quota" in a single week ... somehow my little `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Blog",
        "title": "Blog"
      }}>{`personal blog`}</a>{` managed to garner the attention of 32,820 visitors. What's stranger still, 96% of these visits were from Friday to Sunday. Mostly because of two posts.`}</p>
    <p>{`Not sure exactly what happened, but apparently people love being told that startups are awesome and `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-i-only-work-with-startups/swizec/2936",
        "title": "Why I only work with startups"
      }}>{`why I love working for them`}</a>{`. Another thing that really seems to pique people's interests are `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/strangest-line-of-python-you-have-ever-seen/swizec/3012",
        "title": "Strangest line of python you have ever seen"
      }}>{`strange lines of python`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-21-at-7.07.47-PM.png",
        "alt": "A good blogging week",
        "title": "A good blogging week"
      }}></img></p>
    <p>{`Those two posts together have been tweeted 242 and G+'d 38 times. Strangely though, this does not beat the record holder - a post about `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/apples-ping-is-a-big-pile-of-steaming-dung/swizec/1444",
        "title": "Apple’s Ping is a big pile of steaming dung"
      }}>{`apple's ping being a big pile of steaming dung`}</a>{` - which managed to get 248 tweets on its own.`}</p>
    <p>{`But all these visits and tweets and comments (about 30 per post) don't mean a single thing without the very important metric of how many people actually read them?`}</p>
    <p>{`I'm happy to say that the post about startups was read to its completion by about 38% of visitors - for a 1000+ word behemot that's `}<em parentName="p">{`a lot`}</em>{` on the internet. The python post also did remarkably well with a 65% completion rate! Yay!`}</p>
    <p>{`I think the python post can easily be explained by all the expert pythoners looking for the punchline since it turned out that line wasn't so much strange as me and my friends are stupid.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-21-at-7.14.29-PM.png",
        "alt": "Even long posts can have good completion rates",
        "title": "Even long posts can have good completion rates"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-21-at-7.15.38-PM.png",
        "alt": "Short confusing posts do _very_ well",
        "title": "Short confusing posts do _very_ well"
      }}></img></p>
    <p>{`You might think the stats for the python post are poisoned by the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Startup_company",
        "title": "Startup company"
      }}>{`startup`}</a>{` post doing so well, but according to `}<a parentName="p" {...{
        "href": "http://www.google.com/analytics",
        "title": "Google Analytics"
      }}>{`google analytics`}</a>{` there was so much significantly more traffic on the python post that this is practically negligible. In fact you can see this in the above cutoff, 11k people on 17th paragraph, and only 1700 on the 18th paragraph, which the python post doesn't have.`}</p>
    <p>{`However, I am happy to say that the post about startups has proven remarkably resiliant and it still got more than 1000 visitors even yesterday.`}</p>
    <p>{`Wonder if I'll ever manage to repeat something like this.`}</p>
    <p>{`Also, mixpanel thinks I'm problematic despite my life-time AppSumo account thing.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-21-at-7.34.35-PM.png",
        "alt": "Mixpanel crying",
        "title": "Mixpanel crying"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.socialmaximizer.com/tweet-your-way-to-1000%e2%80%99s-of-followers/"
        }}>{`Top 10 Tips to Tweet your way to 1000's of Followers`}</a>{` (socialmaximizer.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eli.thegreenplace.net/2011/07/12/helping-improve-the-documentation-of-python/"
        }}>{`Helping improve the documentation of Python`}</a>{` (eli.thegreenplace.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.nicosphere.net/urwid-for-python-a-ncurses-library-2541/"
        }}>{`Urwid For Python, A Ncurses Library`}</a>{` (nicosphere.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/startup-rollercoaster-isnt-even-the-half-of-it/swizec/2712"
        }}>{`"Startup rollercoaster" isn't even the half of it`}</a>{` (swizec.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=02ff9b7e-b2e9-43ee-9abf-dbc8874593e5",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      